<template>
	<div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <div class="media">
                    <div class="align-self-center mr-3" v-tooltip="'Creado Por'">
                        <i class="material-icons">person_add</i>
                    </div>
                    <div class="media-body">
                        <small>Creado Por:</small>
                        <p class="m-0">
                            <usuario v-bind:data="info.CREADO_POR"></usuario>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="media">
                    <div class="align-self-center mr-3" title="Actualizado Por">
                        <i class="material-icons">person_outline</i>
                    </div>
                    <div class="media-body">
                        <small>Actualizado Por:</small>
                        <p class="m-0">
                            <usuario v-bind:data="info.ACTUALIZADO_POR"></usuario>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="media">
                    <div class="align-self-center mr-3" title="Fecha Creación">
                        <i class="material-icons">access_time</i>
                    </div>
                    <div class="media-body">
                        <small>Fecha Creación:</small>
                        <p class="m-0" v-if="info.FECHA_CREACION">
                            {{info.FECHA_CREACION}}
                        </p>
                        <span class="text-muted" v-else>
                            --No definida--
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="media">
                    <div class="align-self-center mr-3" title="Fecha Actualización">
                        <i class="material-icons">update</i>
                    </div>
                    <div class="media-body">
                        <small>Fecha Actualización:</small>
                        <p class="m-0" v-if="info.FECHA_ACTUALIZACION">
                            {{info.FECHA_ACTUALIZACION}}
                        </p>
                        <span class="text-muted" v-else>
                            --No definida--
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="media">
                    <div class="align-self-center mr-3" title="Creado Desde">
                        <i class="material-icons">add_location</i>
                    </div>
                    <div class="media-body">
                        <small>Creado Desde:</small>
                        <p class="m-0" v-if="info.CREADO_DESDE">
                            {{info.CREADO_DESDE}}
                        </p>
                        <span class="text-muted" v-else>
                            --No definido--
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="media">
                    <div class="align-self-center mr-3" title="Actualizado Desde">
                        <i class="material-icons">edit_location</i>
                    </div>
                    <div class="media-body">
                        <small>Actualizado Desde:</small>
                        <p class="m-0" v-if="info.ACTUALIZADO_DESDE">
                            {{info.ACTUALIZADO_DESDE}}
                        </p>
                        <span class="text-muted" v-else>
                            --No definido--
                        </span>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
	export default{
		props: ['data'],

        computed: {
            info: function () {
                return JSON.parse(this.data);
            },
        }
	}
</script>